import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_FIELD_STRUCTURE_API} from '@app/reactQuery/apis/constants';

export const RQUseGetFieldStructureData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_field_structure_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_FIELD_STRUCTURE_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};
